// DashboardInvoiceItem Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'

import currency from '../../../lib/currency.jsx'
import IntlMessage from '../../common/intl/intl_message.jsx'
import DateUtil from '../../../lib/dateutil.jsx'
import IconButton from '../../../common/common/icon_button/icon_button.jsx'
import PriceText from '../../../common/common/price_text/price_text.jsx'

class DashboardInvoiceItem extends Component {
  static get propTypes () {
    return {
      invoice: PropTypes.object,
      onClick: PropTypes.func,
      onView: PropTypes.func,
      onResendMail: PropTypes.func,
      bShowReminder: PropTypes.bool,
      useProjectNumber: PropTypes.bool
    }
  }

  static get defaultProps () {
    return {
      invoice: null,
      onClick: null,
      onView: null,
      onResendMail: null,
      bShowReminder: false,
      useProjectNumber: false
    }
  }

  render () {
    const invoice = this.props.invoice
    const date = invoice.invoiceDate
      ? new Date(invoice.invoiceDate)
      : new Date()
    const bShowReminderText = invoice.lastReminderDate
      ? DateUtil.isDateEqual(
        invoice.lastReminderDate,
        DateUtil.getUTCCurrentDate()
      )
      : false

    const projectTitle = [
      this.props.useProjectNumber && invoice.project.projectNumber,
      invoice.project.title
    ]
      .filter(Boolean)
      .join(' / ')

    return (
      <div className='dashboard-invoiceitem' onClick={this._onClick.bind(this)}>
        <div className='coldate'>
          <div className='month'>{DateUtil.getDisplayMonth(date)}</div>
          <div className='day'>{DateUtil.getDisplayDay(date)}</div>
        </div>
        <div className='split' />
        <div className='colcontent'>
          <h2 className='title'>{invoice.contact.company}</h2>
          <div className='project-title' title={projectTitle}>
            {projectTitle}
          </div>
          <div className='info'>
            <span className='number'>{invoice.invoiceNo}</span>
            <span className='split' />
            <span className='date'>
              {DateUtil.displayHumanized(invoice.dueDate)}
            </span>
            {bShowReminderText && invoice.status === 'Overdue' && (
              <span className='split' />
            )}
            {bShowReminderText && invoice.status === 'Overdue' && (
              <span className='date'>
                <IntlMessage ident='invoice.list.invoiceReminderInfo' />
              </span>
            )}
          </div>
        </div>
        <div className='split' />
        <div className='colamount'>
          {this.props.bShowReminder && !bShowReminderText && (
            <IconButton
              icon='common-mailresend'
              size='big'
              className='resend'
              type='error'
              onClick={this._onResendMail.bind(this)}
              canHover={false}
            />
          )}
          <h2 className='total'>
            <span className='price'>
              {invoice.total ? (
                <PriceText value={invoice.total} />
              ) : (
                currency.format()
              )}
            </span>
          </h2>
          <div className='vatvalue'>
            <span className='info'>
              <IntlMessage ident='common.dashboard.vatIncText' />
            </span>
            <span className='value'>
              {invoice.totalInc ? (
                <PriceText value={invoice.totalInc} />
              ) : (
                <PriceText value='' />
              )}
            </span>
          </div>
        </div>
      </div>
    )
  }

  _onClick (event) {
    event.preventDefault()

    if (this.props.onView) {
      this.props.onView(this.props.invoice)
    }
  }

  _onResendMail (ev) {
    ev.preventDefault()
    ev.stopPropagation()

    if (this.props.onResendMail) {
      this.props.onResendMail(this.props.invoice)
    }
  }
}

export default DashboardInvoiceItem
